import type {
  AddBroadbandOffer,
  AddMobileOffer,
} from '@/services/apis/getQuoteSummary/schemas';

export const createMobileOfferPayload = (
  mobilePlanId: number
): AddMobileOffer => {
  const mobile: AddMobileOffer = {
    mobile: {
      offers: [
        {
          id: mobilePlanId,
          quantity: 1,
        },
      ],
    },
  };
  return mobile;
};

export const createBroadbandOfferPayload = ({
  broadbandPlanId,
  NDCfeatureId,
}: {
  broadbandPlanId: number;
  NDCfeatureId: number | null;
}): AddBroadbandOffer => {
  const broadband = {
    broadband: {
      offers: [
        {
          id: broadbandPlanId,
          ...(NDCfeatureId && {
            features: [{ id: NDCfeatureId }],
          }),
        },
      ],
    },
  } satisfies AddBroadbandOffer;
  return broadband;
};
